import * as Types from '../constants/Types';

export const dataUserAction = (filters) => ({ type: Types.USER_LIST_ACTION, filters });
export const dataUserSuccess = (users) => ({ type: Types.USER_LIST_SUCCESS, users });

export const createUserAction = (params) => ({ type: Types.USER_CREATE_ACTION, params });
export const deleteUserAction = (params) => ({ type: Types.USER_DELETE_ACTION, params });

export const getUpdateUserAction = (params) => ({ type: Types.USER_GET_UPDATE_ACTION, params });
export const getUpdateUserSuccess = (dataUpdate) => ({ type: Types.USER_GET_UPDATE_SUCCESS, dataUpdate });

export const updateUserAction = (params) => ({ type: Types.USER_UPDATE_ACTION, params });
export const updateForceMfaAction = (params) => ({ type: Types.USER_FORCE_MFA_UPDATE_ACTION, params });
export const updateForceMfaSuccess = (params) => ({ type: Types.USER_FORCE_MFA_UPDATE_SUCCESS, params });
export const updateForceMfaFail = (params) => ({ type: Types.USER_FORCE_MFA_UPDATE_FAIL, params });

export const getRoleUserAction = (filters) => ({ type: Types.USER_GET_ROLE_ACTION, filters });
export const getRoleUserSuccess = (roleUser) => ({ type: Types.USER_GET_ROLE_SUCCESS, roleUser });

export const changePasswordUserAction = (params) => ({ type: Types.USER_CHANGE_PASSWORD_ACTION, params });

export const getCSUserAction = (params) => ({ type: Types.USER_GET_CS_USER_ACTION, params });
export const getCSUserSuccess = (csUsers) => ({ type: Types.USER_GET_CS_USER_SUCCESS, csUsers });

export const getCustomerUserAction = (params) => ({ type: Types.USER_GET_CUSTOMER_USER_ACTION, params });
export const getCustomerUserSuccess = (customerUsers) => ({ type: Types.USER_GET_CUSTOMER_USER_SUCCESS, customerUsers });
